export default "__VITE_ASSET__DcXtJe81__"